import { useEffect } from 'react';

const EVENT_NAME = 'CodeEditorInsertValue';

export function insertValueAtCursor(detail) {
    document.dispatchEvent(new CustomEvent(EVENT_NAME, { detail }));
}

export function useValueInserter(editor) {
    useEffect(() => {
        function handler({ detail }) {
            const { state, dispatch } = editor;
            dispatch(state.replaceSelection(detail));
            editor.focus();
        }

        document.addEventListener(EVENT_NAME, handler);
        return () => document.removeEventListener(EVENT_NAME, handler);
    }, [editor]);
}
